import api from './api/client';

const menuItems = {
    items: [
        {
            id: 'navigation',
            title: 'Home',
            type: 'group',
            icon: 'icon-navigation',
            children: [
                {
                    id: 'dashboard',
                    title: 'Dashboard',
                    type: 'item',
                    url: '/app/dashboard',
                    icon: 'feather icon-home'
                }
            ]
        },
        {
            id: 'navigation1',
            title: 'Weather',
            type: 'group',
            icon: 'icon-navigation',
            children: [
                {
                    id: 'dashboardandinsights',
                    title: 'Weather & Insights',
                    type: 'item',
                    url: '/weather/insights',
                    icon: 'feather icon-cpu'
                }
            ]
        },
        {
            id: 'teamspace',
            title: 'Team Space',
            type: 'group',
            icon: 'icon-calendar',

            children: [
                {
                    id: 'worksapce',
                    title: 'Workspace',
                    type: 'item',
                    url: '/workspace',
                    icon: 'feather icon-calendar'
                },
                {
                    id: 'communication2',
                    title: 'Messaging',
                    type: 'item',
                    url: '/messages',
                    icon: 'feather icon-message-circle'
                }
            ]
        },
        {
            id: 'payslip',
            title: 'Payslip Management',
            type: 'group',
            icon: 'icon-cash-register',

            children: [
                {
                    id: 'payslip1',
                    title: 'Payslip',
                    type: 'item',
                    url: '/payslip',
                    icon: 'feather icon-credit-card'
                }
            ]
        },

        {
            id: 'farm-assets',
            title: 'Asset Management',
            type: 'group',
            icon: 'icon-group',

            children: [
                {
                    id: 'assets',
                    title: 'Assets',
                    type: 'item',
                    icon: 'feather icon-map',
                    url: '/animal-assets'
                },
                {
                    id: 'farms1',
                    title: 'Farms',
                    type: 'collapse',
                    icon: 'feather icon-pocket',

                    children: [
                        {
                            id: 'farms2',
                            title: 'Farms',
                            type: 'item',
                            url: '/farms'
                        },

                        // {
                        //     id: 'farms3',
                        //     title: 'Manage Farms',
                        //     type: 'item',
                        //     url: '/farms/manage'
                        // },
                        // {
                        //     id: 'farms31',
                        //     title: 'Farm Items',
                        //     type: 'item',
                        //     url: '/farm-items'
                        // },
                        {
                            id: 'farms32',
                            title: 'Company Profile',
                            type: 'item',
                            url: '/farm/profile'
                        }
                    ]
                },
                {
                    id: 'manage-animals',
                    title: 'Manage Animals',
                    type: 'collapse',
                    icon: 'feather icon-compass',

                    children: [
                        {
                            id: 'animal-mating',
                            title: 'Animals Mating',
                            type: 'item',
                            // icon: 'feather icon-sliders',
                            url: '/animals/mating'
                        },
                        // {
                        //     id: 'animal-cycles',
                        //     title: 'Animal Cycles',
                        //     type: 'item',
                        //     url: '/animal-cycles'
                        // },
                        // {
                        //     id: 'animal-weights1',
                        //     title: 'Animals Growth',
                        //     type: 'item',
                        //     // // icon: 'feather icon-sliders',
                        //     url: '/animal-growth'
                        // },
                        {
                            id: 'animal-weights1',
                            title: 'Animals Growth',
                            type: 'item',
                            // // icon: 'feather icon-sliders',
                            url: '/animal-growth'
                        },
                        {
                            id: 'animal-slaughter-waste',
                            title: 'Animal Slaughter',
                            type: 'item',
                            url: '/animal/waste-management'
                        }
                    ]
                },
                {
                    id: 'poultry5',
                    title: 'Eggs Update',
                    type: 'item',
                    url: '/eggs-update',
                    icon: 'feather icon-award'
                }
            ]
        },
        {
            id: 'admins',
            title: 'HR Management',
            type: 'group',
            icon: 'icon-group',

            children: [
                {
                    id: 'add-stakeholders',
                    title: 'Stakeholders',
                    type: 'item',
                    url: '/stakeholders',
                    icon: 'feather icon-image'
                },
                {
                    id: 'admins1',
                    title: 'Users',
                    type: 'collapse',
                    icon: 'feather icon-users',

                    children: [
                        {
                            id: 'admins3',
                            title: 'Users',
                            type: 'item',
                            url: '/users'
                        },
                        {
                            id: 'admins5',
                            title: 'Roles',
                            type: 'item',
                            url: '/users/roles'
                        }
                    ]
                },
                {
                    id: 'attendance',
                    title: 'Attendance',
                    type: 'collapse',
                    icon: 'feather icon-server',

                    children: [
                        {
                            id: 'clock',
                            title: 'Attendance Clock',
                            type: 'item',
                            url: '/attendance/clock'
                        },
                        {
                            id: 'daily-logs',
                            title: 'Daily Logs',
                            type: 'item',
                            url: '/attendance/daily-logs'
                        }
                    ]
                },
                {
                    id: 'payroll',
                    title: 'Payroll',
                    type: 'collapse',
                    icon: 'feather icon-repeat',

                    children: [
                        {
                            id: 'payroll1',
                            title: 'Generate Payroll',
                            type: 'item',
                            url: '/payroll/generate-payroll'
                        },
                        {
                            id: 'payroll3',
                            title: 'Payroll Management',
                            type: 'item',
                            url: '/payroll/management'
                        },

                        {
                            id: 'salary33',
                            title: 'Salary Settings',
                            type: 'item',
                            url: '/payroll/salary-settings'
                        }
                    ]
                },
                {
                    id: 'leave',
                    title: 'Leave Management',
                    type: 'collapse',
                    icon: 'feather icon-pie-chart',

                    children: [
                        {
                            id: 'leaverequests',
                            title: 'Leave Requests',
                            type: 'item',
                            url: '/leave/requests'
                        },
                        {
                            id: 'calendarview',
                            title: 'Calendar View',
                            type: 'item',
                            url: '/leave/calendar-view'
                        },
                        {
                            id: 'myleave',
                            title: 'My Leave',
                            type: 'item',
                            url: '/leave/my-requests'
                        }
                    ]
                },
                {
                    id: 'hrmanagement',
                    title: 'Departments',
                    type: 'item',
                    icon: 'feather icon-bookmark',
                    url: '/departments'
                },
                {
                    id: 'internal',
                    title: 'Internal Consumption',
                    type: 'item',
                    icon: 'feather icon-package',
                    url: '/internal-consumption'
                }
            ]
        },
        {
            id: 'finance-22',
            title: 'Finance Management',
            type: 'group',
            icon: 'icon-group',

            children: [
                {
                    id: 'list-inventory',
                    title: 'Inventory',
                    type: 'item',
                    icon: 'feather icon-globe',
                    url: '/inventory'
                },
                {
                    id: 'sales-invoices',
                    title: 'Sales',
                    type: 'item',
                    icon: 'feather icon-shopping-cart',
                    url: '/sales'
                },

                {
                    icon: 'feather icon-lock',
                    id: 'payments22',
                    title: 'Payments',
                    type: 'item',
                    url: '/payments'
                },
                {
                    id: 'journals3',
                    title: 'Journals Entries',
                    icon: 'feather icon-save',
                    type: 'item',
                    url: '/journals'
                },
                {
                    icon: 'feather icon-layers',
                    id: 'chart-accounts',
                    title: 'Chart of Accounts',
                    type: 'item',
                    url: '/accounts/chart-accounts'
                },
                {
                    icon: 'feather icon-layers',
                    id: 'all-transactions',
                    title: 'All Transactions',
                    type: 'item',
                    url: '/transactions'
                }
            ]
        },
        {
            id: 'report44',
            title: 'Analytics Management',
            type: 'group',
            icon: 'icon-group',

            children: [
                {
                    id: 'accounting2',
                    title: 'Financial Reports',
                    type: 'collapse',
                    icon: 'feather icon-bar-chart-2',
                    children: [
                        {
                            id: 'General-Ledger',
                            title: 'General Ledger',
                            type: 'item',
                            url: '/reports/general-ledger'
                        },
                        {
                            id: 'Trial-Balance',
                            title: 'Trial Balance',
                            type: 'item',
                            url: '/reports/trial-balance'
                        },
                        {
                            id: 'Balance-Sheet',
                            title: 'Balance Sheet',
                            type: 'item',
                            url: '/reports/balance-sheet'
                        },
                        {
                            id: 'Income-Statement',
                            title: 'Income Statement',
                            type: 'item',
                            url: '/reports/income-statement'
                        }
                    ]
                },

                {
                    id: 'admins66',
                    title: 'Inventory Reports',
                    type: 'item',
                    icon: 'feather icon-bar-chart-2',
                    url: '/reports/inventory'
                },
                {
                    id: 'admins234',
                    title: 'Logs',
                    type: 'item',
                    icon: 'feather icon-clock',
                    url: '/logs'
                }
            ]
        }
    ]
};

export default menuItems;
